module.exports = __webpack_public_path__ + "static/team3-dc3a5f8b64d9dcc6594f1ad2c299ac74.png";